import React from 'react';
import NextLink from 'next/link';
import styled from 'styled-components';

const StyledLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.link};

  :focus,
  :hover {
    text-decoration: underline;
  }
  :active,
  :visited {
    color: ${({ theme }) => theme.link};
  }
`;

type LinkProps = {
  href: string;
  className?: string;
  openInNewTab?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

const Link: React.FC<LinkProps> = ({
  href,
  className,
  openInNewTab,
  onClick,
  children,
}) => {
  return (
    <NextLink href={href} passHref>
      <StyledLink
        className={className}
        onClick={onClick}
        target={openInNewTab ? '_blank' : null}
        rel={openInNewTab ? 'noopener noreferrer' : null}
      >
        {children}
      </StyledLink>
    </NextLink>
  );
};

export default Link;
